import { Dispatch, SetStateAction, useState } from 'react';
import { useNotificationService } from '../../../../services/notification.service';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import { IArquivoDespesaCleanDTO, IDespesaFullDTO, IDespesaPagamentoDTO } from '../../../../models/happy-code-api.model';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { useArquivoService } from '../../../../services/arquivo.service';
import FileSaver from 'file-saver';
import { UploadFileWithDesc } from '../types/file-interface';
import axios from 'axios';
import { token } from '../../../../util/store';
import useValidationFormDespesa from './validation-form';
import { useParams } from 'react-router-dom';
import { useDespesaService } from '../../../../services/despesa.service';

export default function useUploadFile(despesa: IDespesaFullDTO | IDespesaPagamentoDTO, setDespesa?: Dispatch<SetStateAction<any>>,) {
	const [fileList, setFileList] = useState<UploadFileWithDesc[]>([]);
	const notification = useNotificationService();
	const { setIsGlobalLoading } = useGlobalContext();
	const despesaService = useDespesaService();
	const arquivoService = useArquivoService();
	const { idDespesa } = useParams<any>()

	const validateFields = useValidationFormDespesa();

	const id = idDespesa ?? undefined

	const validateBeforeUpload = (file: UploadFile) => {
		const isValid = file !== undefined && (file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/png');
		if (!isValid) return false;

		return true;
	};

	const onDelete = (file: UploadFile) => {
		setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
	};

	const onChangeUpload = ({ file, fileList }: UploadChangeParam<UploadFile>) => {
		if (!validateBeforeUpload(file)) {
			notification({
				description: `Apenas arquivos PNG, JPG e PDFs são permitidos.`,
				type: 'error',
				message: 'Erro!',
			});
			return;
		}
		const { status, response } = file;

		const updatedList: UploadFile[] = fileList.map((f) => {
			if (f.uid === file.uid && response?.id) {
				return {
					...f,
					status: 'done',
					response: response,
				};
			}
			return f;
		});

		if (response?.id) {
			const atual = updatedList.find((f) => f.uid === file.uid) as UploadFileWithDesc;

			setDespesa((prev) => {
				const base = prev ?? {};

				return {
					...base,
					arquivosDespesa: [
						...(base.arquivosDespesa ?? []),
						{
							arquivo: { id: response.id },
							descricao: atual?.description ?? '',
						} as IArquivoDespesaCleanDTO,
					],
				};
			});
		}

		setFileList(updatedList);

		if (status === 'error') {
			notification({
				description: `${file.name} falha ao fazer o upload do arquivo`,
				type: 'error',
				message: 'Erro!',
			});
		}
	};

	const downloadFile = (hash: string, fileName: string): any => {
		setIsGlobalLoading(true);
		arquivoService
			.download(hash, fileName)
			.then((response) => {
				const blob = new Blob([response.data], {
					type: 'application/octet-stream',
				});
				FileSaver.saveAs(blob, fileName);
			})
			.finally(() => setIsGlobalLoading(false));
	};
	const clearFileList = () => setFileList([]);

	const uploadOne = async (f: UploadFileWithDesc) => {
		setIsGlobalLoading(true);
		const form = new FormData();
		form.append('file', f.originFileObj as any);
		form.append('descricao', f.description || '');

		const { data } = await axios.post(`${process.env.REACT_APP_HAPPYCODE_PUBLIC_BASE_URL_API}arquivo/upload/descricao`, form, {
			headers: { Authorization: `Bearer ${token()}` },
		});

		despesa.arquivosDespesa = [
			...(despesa.arquivosDespesa ?? []),
			{ arquivo: { id: data.id }, descricao: f.description ?? '' } as IArquivoDespesaCleanDTO,
		];

		return data;
	};

	const updateDescription = (uid: string, text: string) => {
		setFileList((prev) => prev.map((f) => (f.uid === uid ? { ...f, description: text } : f)));
	};

	const syncUploads = async (): Promise<boolean> => {
		if(fileList.length === 0) return true;
		if (!validateFields(despesa as IDespesaFullDTO, id)) return false;

		const pendentes = fileList.filter((f) => f.response === 'ok');
		const validos = pendentes.filter((f) => validateBeforeUpload(f.originFileObj));
		if (validos.length) {
			await Promise.all(validos.map(uploadOne));
		}

		return true;
	};
	const syncUploadsPayment = async (): Promise<boolean> => {

		const pendentes = fileList.filter((f) => f.response === 'ok');
		const validos = pendentes.filter((f) => validateBeforeUpload(f.originFileObj));
		if (validos.length) {
			await Promise.all(validos.map(uploadOne));
		}

		return true;
	};


	const onDeleteById = async (file: UploadFile) => {
		if (file.response?.id) {
			try {
				await despesaService.excluirArquivoDaDespesa(Number(idDespesa), file.response.id);
				setDespesa((prev) => ({
					...prev,
					arquivosDespesa: prev.arquivosDespesa?.filter((a) => a.arquivo.id !== file.response.id),
				}));
				notification({ message: 'Sucesso!', description: 'Arquivo excluído com sucesso.', type: 'success' });
			} catch (error) {
				notification({ message: 'Erro!', description: 'Falha ao excluir o anexo.', type: 'error' });
				return;
			}
		}
		setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
	};
	

	return {
		onChangeUpload,
		onDelete,
		fileList,
		downloadFile,
		clearFileList,
		updateDescription,
		uploadOne,
		syncUploads,
		syncUploadsPayment,
		onDeleteById
	};
}
